export default __webpack_public_path__ + "static/Greycliffcf-bold-webfont-a65cb04e80f809147af0e5b8fa2b9306.woff";